import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ImageService } from 'src/app/shared/services/image.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ITranslatableText } from 'src/app/store/services/store.service';
import { ApiControllerService } from './api-controller.service';

export interface INews {
  id?: string;
  merchantId: string;
  name: ITranslatableText;
  news: ISingleNews[];

  deactivate: boolean;
  dayButtonColor: ICategoryUI;
  weeklyFormat?: boolean;

  creationEditingData?: ICreationEditingData;
}

export interface IBlogs {
  id?: string;
  merchantId: string;
  name: ITranslatableText;
  blogs: ISingleBlog[];

  deactivate: boolean;
  dayButtonColor: ICategoryUI;
  weeklyFormat?: boolean;

  creationEditingData?: ICreationEditingData;
}

export interface ISingleNews {
  id: string;
  title: ITranslatableText;
  storeBound: boolean;
  locations?: string[];
  images?: INewsBlogImg;
  shortDescription: ITranslatableText;
  longDescription: ITranslatableText;
  btnText: ITranslatableText;
  btnLink: ITranslatableText; // this one has a Itrnslatable text due to the fact that we can add fr and en links
  btnColor: string;
  btnTextColor: string;
  disclaimer: ITranslatableText;
  modalityLink?: ITranslatableText;
  deactivate: boolean;
  promotionalCode?: string;
  pricingReference?: IPricingReference;

  members: boolean;
  guests: boolean;
  membersAndGuests: boolean;

  activationDate?: Date;
  noExpiration?: boolean;
  expirationDate?: Date;
  //weeklyFormat?: boolean;
  dailyShowcase?: IDailyShowcase[];

  creationEditingData?: ICreationEditingData;
}

export interface ISingleBlog {
  id: string;
  title: ITranslatableText;
  storeBound: boolean;
  locations?: string[];
  images?: INewsBlogImg;
  shortDescription: ITranslatableText;
  longDescription: ITranslatableText;
  btnText: ITranslatableText;
  btnLink: ITranslatableText; // this one has a Itrnslatable text due to the fact that we can add fr and en links
  btnColor: string;
  btnTextColor: string;
  disclaimer: ITranslatableText;
  modalityLink?: ITranslatableText;
  deactivate: boolean;
  promotionalCode?: string;
  pricingReference?: IPricingReference;

  members: boolean;
  guests: boolean;
  membersAndGuests: boolean;

  activationDate?: Date;
  noExpiration?: boolean;
  expirationDate?: Date;
  //weeklyFormat?: boolean;
  dailyShowcase?: IDailyShowcase[];

  creationEditingData?: ICreationEditingData;
}

export interface ICreationEditingData {
  creationDate: Date;
  editingDate: Date;
  createdBy: string;
  lastEditedBy: string;
}

export interface ICategoryUI {
  dayButtonColor: string;
  dayButtonTextColor: string;
}

export interface IPricingReference {
  showPricing: boolean;
  price: number;
}

export interface IDailyShowcase {
  dayID: number[];
  hoursRange: IHoursRange;
}

export interface IHoursRange {
  startHours: string;
  endHours: string;
}

export interface INewsBlogImg {
  imgShortName: string;
  imgDisplayName: string;
  imgMobileShortName: string;
  imgMobileDisplayName: string;

  imgURL: any;
  imgMobileURL: any;
}


export interface IBaseNewsRequest {
  merchantId: string;
  userId?: string;
}

export interface IBaseBlogsRequest {
  merchantId: string;
  userId?: string;
}

export interface IBlogsUpdateRequest {
  merchantId: string;
  userId: string;
  blogId: string;
  status: string;
}

export interface INewsUpdateRequest {
  merchantId: string;
  userId: string;
  newsId: string;
  status: string;
}

export interface INewsDeleteAllRequest {
  merchantId: string;
  userId: string;
  newsList: INewsList[];
}

export interface INewsList {
  newsId: string;
  status: string;
}

export interface IBlogsDeleteAllRequest {
  merchantId: string;
  userId: string;
  blogList: IBlogsList[];
}

export interface IBlogsList {
  blogsId: string;
  status: string;
}



export interface IimageLibraryData {
  shortNameReference: string;
  valueImageCollected: string;
}

export const DayIDEnum  = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 4,
  Thursday: 8,
  Friday: 16,
  Saturday: 32,
  Sunday: 64
}

export interface ICategoryDaysAssign {
  categoryId: string;
  days: IDaysAssign[];
  selectedDay?: number;
}

export interface IDaysAssign {
  value: number;
  viewValue: ITranslatableText;
  selected: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NewsBlogsService {

  isNavBarImageLoaded: boolean = false;

  get getnavbarImageLoaded(): boolean {
    return this.isNavBarImageLoaded;
  }
  imageLibrary: IimageLibraryData[] = [];

  blogsPreload: IBlogs[] = [];
  newsPreload: any[] = [];

  blogchange: boolean = true;
  newschange: boolean = true;

  get blogs(): any[] {
    return this.blogsPreload;
  }

  get news(): any[] {
    return this.newsPreload;
  }

  constructor(private http: HttpClient,
    private settingService: SettingService,
    private imageService: ImageService,
    private sanitizer: DomSanitizer,
    private apiController: ApiControllerService
  ) { }


  /*
  getNews(newsRequest: IBaseNewsRequest): Observable<INews[]> {
    return Observable.create(o => {

      if(this.newsPreload.length == 0 || this.newschange) {
        this.http.post(this.settingService.apiUrl('News/GetNews'), newsRequest)
        .subscribe((data: any[]) => {
          this.newsPreload = data;
          
          // fetching images in advance or refreshing it
        

          o.next(data);
          o.complete();
        });
      } else {
        o.next(this.newsPreload);
        o.complete();
      }
      
    })
  }
    */

  getNews(newsRequest: IBaseNewsRequest): Observable<INews[]> {
    return new Observable(o => {
      if (this.newsPreload.length === 0 || this.newschange) {
        /* this.http.post<IBlogs[]>(this.settingService.apiUrl('Blogs/GetBlogs'), blogsRequest)
          .subscribe(async (data) => {
            this.blogsPreload = data;

            // Fetch all images in parallel
            const imagePromises = this.blogsPreload.map(async (blogs) => {
              blogs.images['imgURL'] = await this.fetchImage(blogs.images.imgShortName);
              blogs.images['imgMobileURL'] = await this.fetchImage(blogs.images.imgMobileShortName);
            });

            await Promise.all(imagePromises);

            this.blogchange = false;
            o.next(this.blogsPreload);
            o.complete();
          }); */

        this.apiController.post<INews[]>(this.settingService.apiUrl('News/GetNews'), newsRequest)
          .subscribe(async (data) => {
            this.newsPreload = data;

            for(var i = 0; i < this.newsPreload.length; i++) {
              var category = this.newsPreload[i];

              const imagePromises = category.news.map(async (news) => {
                news.images['imgURL'] = await this.fetchImage(news.images.imgShortName);
                news.images['imgMobileURL'] = await this.fetchImage(news.images.imgMobileShortName);
              });

              await Promise.all(imagePromises);
            }

            // Fetch all images in parallel
            /*
            const imagePromises = this.blogsPreload.map(async (blogs) => {
              blogs.images['imgURL'] = await this.fetchImage(blogs.images.imgShortName);
              blogs.images['imgMobileURL'] = await this.fetchImage(blogs.images.imgMobileShortName);
            });
            */

            //await Promise.all(imagePromises);

            this.newschange = false;
            o.next(this.newsPreload);
            o.complete();
          });

      } else {
        console.log("preloaded");
        o.next(this.newsPreload);
        o.complete();
      }

    });
  }

  getBlogs(blogsRequest: IBaseBlogsRequest): Observable<IBlogs[]> {
    return new Observable(o => {
      if (this.blogsPreload.length === 0 || this.blogchange) {

        this.apiController.post<IBlogs[]>(this.settingService.apiUrl('Blogs/GetBlogs'), blogsRequest)
          .subscribe(async (data) => {
            this.blogsPreload = data;

            for(var i = 0; i < this.blogsPreload.length; i++) {
              var category = this.blogsPreload[i];

              const imagePromises = category.blogs.map(async (blog) => {
                blog.images['imgURL'] = await this.fetchImage(blog.images.imgShortName);
                blog.images['imgMobileURL'] = await this.fetchImage(blog.images.imgMobileShortName);
              });

              await Promise.all(imagePromises);
            }

            this.blogchange = false;
            o.next(this.blogsPreload);
            o.complete();
          });

      } else {
        console.log("preloaded");
        o.next(this.blogsPreload);
        o.complete();
      }

    });
  }

  updateNews(updateNewsRequest: INewsUpdateRequest): Observable<INews[]> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('News/UpdateNews'), updateNewsRequest)
        .subscribe((data: any) => {
          this.newschange = true;
          o.next(data);
          o.complete();
        }); */

      this.apiController.post(this.settingService.apiUrl('News/UpdateNews'), updateNewsRequest)
        .subscribe((data: any) => {
          this.newschange = true;
          o.next(data);
          o.complete();
        });
    })
  }

  updateBlogs(updateBlogsRequest: IBlogsUpdateRequest): Observable<IBlogs[]> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Blogs/UpdateBlogs'), updateBlogsRequest)
        .subscribe((data: any) => {
          this.blogchange = true;
          o.next(data);
          o.complete();
        }); */

      this.apiController.post(this.settingService.apiUrl('Blogs/UpdateBlogs'), updateBlogsRequest)
        .subscribe((data: any) => {
          this.blogchange = true;
          o.next(data);
          o.complete();
        });
    })
  }

  deleteAllNews(deleteAllNewsRequest: INewsDeleteAllRequest): Observable<INews[]> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('News/DeleteAllNews'), deleteAllNewsRequest)
        .subscribe((data: any) => {
          this.newschange = true;
          o.next(data);
          o.complete();
        }); */

      this.apiController.post(this.settingService.apiUrl('News/DeleteAllNews'), deleteAllNewsRequest)
        .subscribe((data: any) => {
          this.newschange = true;
          o.next(data);
          o.complete();
        });
    })
  }

  deleteAllBlogs(deleteAllBlogsRequest: IBlogsDeleteAllRequest): Observable<IBlogs[]> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Blogs/DeleteAllBlogs'), deleteAllBlogsRequest)
        .subscribe((data: any) => {
          this.blogchange = true;
          o.next(data);
          o.complete();
        }); */
      this.apiController.post(this.settingService.apiUrl('Blogs/DeleteAllBlogs'), deleteAllBlogsRequest)
        .subscribe((data: any) => {
          this.blogchange = true;
          o.next(data);
          o.complete();
        });
    })
  }

  


  // complimentary methods

  getImage(path: string): Observable<Blob> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              o.error(res);
          }
        ) */
      this.apiController.post(this.settingService.apiUrl('Menu/GetMenuItemImage'), {
        path: path
      }, { responseType: 'blob' })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          result => o.next(result),
          res => {
            if (res.status != 400)
              o.error(res);
          }
        )
    });
  }

  fetchImage(ImageShortname) {
    return new Promise((resolve, reject) => {
      if (ImageShortname != null && ImageShortname != "") {

        var imageData = this.preloadedImage(ImageShortname);

        if(imageData == "") {
          this.getImage(ImageShortname).subscribe(data => {
            this.imageService.createImageFromBlob(data)
            .pipe(finalize(() => {
                
            }))
            .subscribe(async (buffer) => {
              this.setloadedImage(ImageShortname, buffer);
              resolve(buffer);
            });       
          }, error => {
          });
        } else {
          resolve(imageData);
        }
      } else {
        resolve('');
      }
    });
  } 



  /////////////////////////////////////////////////////////////////////////////////
  // preload

  


  setloadedImage(ImageShortname, imageBuffer) {
    var valueReference = {
      shortNameReference: ImageShortname,
      valueImageCollected: imageBuffer
    }

    this.imageLibrary.push(valueReference); 
  }

  preloadedImage(ImageShortname): string {
    const match = this.imageLibrary.find(
      item => item.shortNameReference === ImageShortname
    );


    if(match) {
      return match.valueImageCollected;
    } else {
      return "";
    }
  }

  /////////////////////////////////////////////////////////////////////////////////
}
